import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {Modulos} from 'src/app/core/modulos';
import {AcessoModuloResolver} from 'src/app/guards/acesso-modulo.resolve';
import {AuthGuard} from 'src/app/guards/auth.guard';
import {CadastrarAcaoExecutadaComponent} from './cadastrar-acao-executada/cadastrar-acao-executada.component';
import {AcaoExecutadaComponent} from './acao-executada.component';


const routes: Routes = [
    {
        path: "acaoExecutada/cadastrar",
        component: CadastrarAcaoExecutadaComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {modulo: Modulos.ACAO_EXECUTADA},
    },
    {
        path: "acaoExecutada",
        component: AcaoExecutadaComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {modulo: Modulos.ACAO_EXECUTADA},
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AcaoExecutadaRoutingModule {
}
